/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SuccessRateByVersionRow interface.
 */
export function instanceOfSuccessRateByVersionRow(value) {
    if (!('completed' in value) || value['completed'] === undefined)
        return false;
    if (!('failed' in value) || value['failed'] === undefined)
        return false;
    if (!('successRate' in value) || value['successRate'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    return true;
}
export function SuccessRateByVersionRowFromJSON(json) {
    return SuccessRateByVersionRowFromJSONTyped(json, false);
}
export function SuccessRateByVersionRowFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'completed': json['completed'],
        'failed': json['failed'],
        'successRate': json['successRate'],
        'total': json['total'],
    };
}
export function SuccessRateByVersionRowToJSON(json) {
    return SuccessRateByVersionRowToJSONTyped(json, false);
}
export function SuccessRateByVersionRowToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'completed': value['completed'],
        'failed': value['failed'],
        'successRate': value['successRate'],
        'total': value['total'],
    };
}
